import React from "react";
import TextArea from "antd/lib/input/TextArea";
import TextField from "@atlaskit/textfield";
import Button from "@atlaskit/button/new";

const TestInputPage = ({ inputType, dataChangeCallback, value }) => {
  return (
    <div>
      {inputType === "CUSTOM_DATA" && (
        <>
          <TextArea
            onChange={dataChangeCallback}
            name="custom_data_textarea"
            value={value}
            resize="auto"
            className="ihub-comment-box"
            rows={10}
          />
          Usually a JSON that the integration action will receive as input data.
        </>
      )}
      {inputType === "ISSUE_KEY" && (
        <>
          <TextField onChange={dataChangeCallback} value={value} />
          Type the isseu key to use the issue as input data to the intergration action.
        </>
      )}
      {inputType === "JQL" && (
        <>
          <TextField onChange={dataChangeCallback} value={value} />
          Type a JQL to get a collection of issues, the program will loop through each issue and send one by on as input to the integration
          action.
        </>
      )}
      {inputType !== "NO_DATA" && (
        <div className="clear-text-btn">
          <Button appearance="subtle" onClick={() => dataChangeCallback({ target: { value: "" } })}>
            Clear text
          </Button>
        </div>
      )}
    </div>
  );
};
export default TestInputPage;
